import { AfterViewInit, Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { StorageService } from 'src/app/services/common/storage';
import { AppState, selectAuthState } from 'src/app/store/app.states';
@Component({
  selector: 'app-vendor-about',
  templateUrl: './vendor-about.component.html',
  styleUrls: ['./vendor-about.component.scss']
})
export class VendorAboutComponent implements OnInit {

  public state: any;
  public isAuthenticated: any;
  constructor(public router: Router, public store: Store<AppState>, public localStorage: StorageService) { }

 
  ngOnInit(): void {
    this.store.select(selectAuthState).subscribe((state) => {
      this.state = state;
      this.localStorage.getItem('isAuthenticated').then(x => {
        this.isAuthenticated = x;
      });
    });
  }
}

